module.exports = __webpack_public_path__ + "img/speach.1ba89c02.png";